import axios from 'axios';

export default axios.create({
    baseURL:'https://expert-educational-consultancy-backend.onrender.com'
    // baseURL: 'http://localhost:4679'
});